import React from "react";
import { Box, Pagination } from "@mui/material";

const Paging = ({ localPage, totalPages, onPageChange }) => {
  const handlePageChange = (event, page) => {
    onPageChange(page);
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      mt={2}
      p={1}
      borderRadius={4}
    >
      <Pagination
        count={totalPages}
        page={localPage}
        color="primary"
        onChange={handlePageChange}
        showFirstButton
        showLastButton
      />
    </Box>
  );
};

export default Paging;
